export const ele_status_hash = {
    1:'未开启',
    2:'已发送通知',
    3:'对方已签约',
    4:'签约完成',
    5:'合同逾期未',
    6:'合同撤销',
    7:'对方拒签'
}